import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {Card} from '@mui/material'
import FlightIcon from '@mui/icons-material/Flight'
import HomeIcon from '@mui/icons-material/Home'

import Form from './components/Form'
import SortTable from './components/SortTable'
import Breadcrumb from 'shared/BreadCrumb'
import {ENDPOINT} from 'config/path'
import './index.scss'
import {toggleLoginPopup} from 'features/Login/login.slice'
import {useLocation, useNavigate} from 'react-router-dom'
import {LazyLoadComponent} from 'react-lazy-load-image-component'
import {resetState} from './viewSchedules.slice'

export const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: '2-digit'
}

const viewScheduleBreadcrumbs = [
    {
        path: `${ENDPOINT.basePath}${ENDPOINT.dashboard}`,
        label: (
            <React.Fragment>
                <HomeIcon /> Home
            </React.Fragment>
        )
    },
    {
        label: 'View schedules'
    }
]

const ViewSchedules = (props: any) => {
    const location = useLocation()
    const defaultValues = useSelector((state: any) => state.viewSchedules.initialValues)
    const date = new Date(defaultValues.flightDateTime)
    const isLoggedIn = useSelector((state: any) => state.login.isLoggedIn)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        if (defaultValues?.carrier === '-Select-' || defaultValues?.from?.length < 1 || defaultValues?.to?.length < 1) {
            navigate(ENDPOINT.homepage)
        }
        if (location.pathname === ENDPOINT.viewSchedule) {
            if (isLoggedIn) {
                dispatch(toggleLoginPopup(false))
            } else {
                dispatch(toggleLoginPopup(true))
            }
        }
        return () => {
            dispatch(resetState())
            dispatch(toggleLoginPopup(false))
        }
    }, [])
    return (
        <div className='main_container'>
            <Breadcrumb list={viewScheduleBreadcrumbs} />
            <div className='view-schedules__container'>
                <div className='backdrop' />
                <Card className='frontdrop-container'>
                    <div className='frontdrop-content'>
                        {typeof defaultValues?.from === 'object' ? (
                            <div className='route-view'>
                                <strong>
                                    {defaultValues.from.city}&nbsp;{defaultValues.from.code}
                                </strong>
                                <FlightIcon />
                                <strong>
                                    {defaultValues.to.city}&nbsp;{defaultValues.to.code}
                                </strong>
                            </div>
                        ) : (
                            <div className='route-view'>
                                <strong>Departure</strong>
                                <FlightIcon />
                                <strong>Arrival</strong>
                            </div>
                        )}
                        <span>{date.toLocaleDateString('en-US', options)}</span>
                    </div>
                </Card>
                <div className='view-container'>
                    <LazyLoadComponent>
                        <Form dateMode='datetime' />
                    </LazyLoadComponent>

                    <SortTable />
                </div>
            </div>
        </div>
    )
}

export default ViewSchedules
